import { mapStores } from 'pinia'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import UserMixin from './User'
import BaseElement from './BaseElement'

export default {
  mixins: [UserMixin, BaseElement],
  emits: [
    'on-focus-name-input',
    'on-blur-name-input'
  ],
  data() {
    return {
      showTableTags: false,
      delayTimeout: null,
      debounceUpdate: null,
    }
  },
  methods: {
    focusNameInput() {
      this.focused = 'name'
      this.$emit('on-focus-name-input')
    },
    blurNameInput() {
      this.focused = null
      this.$emit('on-blur-name-input')
    },
  },
  computed: {
    ...mapStores(useBcDocumentStore),
    blackBackground() {
      return this.element?.file?.previews && this.element?.file?.previews['500x500'] && this.element?.file?.black_background
    },
    fileName: {
      get() {
        return this.data.name || this.focused === 'name'
          ? this.data.name
          : this.element.file?.name
      },
      set(val) {
        this.data.name = val ? val : this.element.file?.name
      }
    },
    file() {
      return this.element?.file
    },
    file_upload() {
      return this.element?.file_upload
    }
  },
  watch: {
    'element.file.file_processed': {
      immediate: true,
      handler(file_processed) {
        if (!this.element || !this.element.id) {
          return
        }

        if (!file_processed) {
          this.bcDocumentStore.updateFilesToAntivirTest(this.element.id, this.element?.file?.id, this.element?.file_upload?.id)
        }
      }
    },
    'element.id': {
      immediate: true,
      handler(id) {
        if (!id || !this.element || !this.element.id || this.element?.file?.file_processed) {
          return
        }

        this.bcDocumentStore.updateFilesToAntivirTest(this.element.id, this.element?.file?.id, this.element?.file_upload?.id)
      }
    }
  }
}